import Vue from "vue";
import VueI18n from "vue-i18n";
import elementEnLocale from "element-ui/lib/locale/lang/en"; // element-ui lang
import elementZhLocale from "element-ui/lib/locale/lang/zh-CN"; // element-ui lang
import elementTwLocale from "element-ui/lib/locale/lang/zh-TW"; // element-ui lang
import enLocale from "./en";
import zhLocale from "./zh";
let enLanguageData = null;
let zhLanguageData = null;
let twLanguageData = null;
import OpenCC from 'opencc-js';
const converter = OpenCC.Converter({ from: 'cn', to: 'tw' });

function translateTextFields(obj) {
        let result = {};
        Object.keys(obj).forEach(key => {
                // console.log(key, obj[key]);
                result[key] = converter(obj[key]);
        });
        return result;
}

let  twl = translateTextFields(zhLocale);


let messages = {
    "en-US": {
        ...enLocale,
        ...elementEnLocale
    },
    "zh-CN": {
        ...zhLocale,
        ...elementZhLocale
    },
        "zh-TW": {
                ...twl,
                ...elementTwLocale
        },
};

// if(localStorage.getItem('zhLanguageData') && !localStorage.getItem('enLanguageData')) {
//     zhLanguageData = JSON.parse(localStorage.getItem('zhLanguageData'));
//     messages = {
//         "en-US": {
//             ...enLocale,
//             ...elementEnLocale
//         },
//         "zh-CN": {
//             ...zhLocale,
//             ...zhLanguageData
//         }
//     };
// }
// if(localStorage.getItem('enLanguageData') && !localStorage.getItem('zhLanguageData')) {
//     enLanguageData = JSON.parse(localStorage.getItem('enLanguageData'));
//     messages = {
//         "en-US": {
//             ...enLocale,
//             ...enLanguageData
//         },
//         "zh-CN": {
//             ...zhLocale,
//             ...elementZhLocale
//         }
//     };
// }
// if(localStorage.getItem('enLanguageData') && localStorage.getItem('zhLanguageData')) {
//     zhLanguageData = JSON.parse(localStorage.getItem('zhLanguageData'));
//     enLanguageData = JSON.parse(localStorage.getItem('enLanguageData'));
//     messages = {
//         "en-US": {
//             ...enLocale,
//             ...enLanguageData
//         },
//         "zh-CN": {
//             ...zhLocale,
//             ...zhLanguageData
//         }
//     };
// }


Vue.use(VueI18n);

// const language = JSON.parse(localStorage.getItem("vuex"))? JSON.parse(localStorage.getItem("vuex")).app.language : "zh-CN";
const i18n = new VueI18n({
  // locale: language, // set locale
  locale: localStorage.getItem('bdLanguageChoose') || 'en-US', // set locale
  messages // set locale messages
});

export default i18n;
